
import Vue from "vue";
import { setAccessToken } from "@/api";
import { postWebsiteInCompany } from "@/api/websites-new";
import { EnterpriseAdapterApi } from "@vacancorp/enterprise.adapter.api.vacanservice.com";

import TheTemplate from "../TheNoSidebarTemplate.vue";
import BaseCloseButton from "@/components/BaseCloseButton.vue";
import WebsiteEditor from "./components/WebsiteEditor.vue";

export default Vue.extend({
  name: "WebsiteCreateScreen",

  components: {
    TheTemplate,
    BaseCloseButton,
    WebsiteEditor,
  },

  methods: {
    async createWebsite(
      website: EnterpriseAdapterApi.RequestPostWebsite
    ): Promise<void> {
      const companyId = this.$auth.companyId;
      if (!companyId) {
        this.$router.replace({ name: "login" });
        return;
      }
      this.$setLoading(true);
      setAccessToken(this.$auth.accessToken);

      await postWebsiteInCompany(companyId, website);

      this.$setLoading(false);
      this.$setChecked(true);
      this.$afterSuccessRequest(() => {
        this.$router.push({
          name: "company-websites",
          params: {
            updated: "true",
          },
        });
      }, 2);
    },

    afterLeave(): void {
      this.$setChecked(false);
    },
  },
});
